import { HeroEventProps } from '@sbercloud/uikit-product-site-hero';

import { ClickAnalyticsType } from '../../../../types';
import { EventOrWebinarType } from '../../../../types/backendContent';
import { scrollToElementWithId } from '../../../../utils/scrollToElementWithId';
import { HERO_BUTTONS } from '../constants';

export const getHeroButtonProps = (
  { status, recordLink, content }: EventOrWebinarType,
  clickAnalytics: (props: ClickAnalyticsType) => void,
): HeroEventProps['button'] => {
  const href = content?.ctaButton?.link.isAnchor
    ? ''
    : content?.ctaButton?.link?.href || '';
  const disabled = content?.ctaButton?.isDisabled;
  const getAnalyticsConfig = (text: string) => {
    const config: ClickAnalyticsType = {
      action: 'click',
      clickZone: 'body',
      clickElement: 'button',
      clickContent: text,
      uniqueId: 'events-hero-block-button',
      transitionType: href ? 'inside-link' : 'outside-link',
      clickZoneCategory: 'site-body',
      transitionUrl: href,
      transitionTypeMetrics: href ? 'internal' : 'external',
    };

    return config;
  };

  switch (status) {
    case 'ACTIVE': {
      const buttonText = content?.ctaButton?.text || HERO_BUTTONS.registration;

      return {
        href,
        label: buttonText,
        disabled,
        type: 'registration',
        onClick: () => {
          clickAnalytics(getAnalyticsConfig(buttonText));

          if (!content?.ctaButton) {
            return scrollToElementWithId('form');
          }

          if (content?.ctaButton?.link.isAnchor) {
            return scrollToElementWithId(content.ctaButton.link.anchor!);
          }
        },
      };
    }

    case 'STOP': {
      const noMaterialsToDownload =
        !recordLink && !content?.form?.isShowMaterials;
      const fallbackText = content?.form?.isShowMaterials
        ? HERO_BUTTONS.registration
        : HERO_BUTTONS.watch;
      const buttonText = content?.ctaButton?.text || fallbackText;
      const getType = () => {
        // TODO: requires validation
        if (content?.form?.isShowMaterials) {
          return 'additional-materials';
        }

        if (recordLink) {
          return 'watch';
        }

        return 'registration-closed';
      };

      return {
        href,
        label: buttonText,
        disabled: disabled || noMaterialsToDownload,
        type: getType(),
        onClick: () => {
          clickAnalytics(getAnalyticsConfig(buttonText));

          if (!content?.ctaButton) {
            if (content?.form?.isShowMaterials) {
              return scrollToElementWithId('form-materials');
            }
            return scrollToElementWithId('video-player');
          }

          if (content?.ctaButton?.link.isAnchor) {
            return scrollToElementWithId(content.ctaButton.link.anchor!);
          }
        },
      };
    }

    default: {
      const buttonText = content?.ctaButton?.text || HERO_BUTTONS.watch;

      return {
        href,
        label: buttonText,
        disabled,
        type: 'watch', // TODO: watch-later?
        onClick: () => {
          clickAnalytics(getAnalyticsConfig(buttonText));

          if (content?.ctaButton?.link.isAnchor) {
            return scrollToElementWithId(content.ctaButton.link.anchor!);
          }
        },
      };
    }
  }
};
